<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Parcours Paraacadémiques" />
            <ParaAcademique />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ParaAcademique from './ParaAcademique.vue';

export default {
    name: 'ParaAcademiquePage',
    components: {
        NavBar,
        PageTitle,
        ParaAcademique,
        FooterComp,
    }
}
</script>